(() => {
  const loadCustomScripts = () => {
    window.custom_scripts.forEach((script) => {
      let s = document.createElement("script");
      s.setAttribute("src", script);
      document.head.insertAdjacentElement("beforeend", s);
    });
  };

  const loadAccesibie = () => {
    (function () {
      var s = document.createElement("script");
      var h = document.querySelector("head") || document.body;
      s.src = "https://acsbapp.com/apps/app/dist/js/app.js";
      s.async = true;
      s.onload = function () {
        acsbJS.init({
          statementLink: "",
          footerHtml: "",
          hideMobile: false,
          hideTrigger: false,
          disableBgProcess: false,
          language: "en",
          position: "right",
          leadColor: "#146FF8",
          triggerColor: "#146FF8",
          triggerRadius: "50%",
          triggerPositionX: "left",
          triggerPositionY: "bottom",
          triggerIcon: "people",
          triggerSize: "bottom",
          triggerOffsetX: 20,
          triggerOffsetY: 20,
          mobile: {
            triggerSize: "small",
            triggerPositionX: "left",
            triggerPositionY: "bottom",
            triggerOffsetX: 10,
            triggerOffsetY: 10,
            triggerRadius: "20",
          },
        });
      };
      h.appendChild(s);
    })();
  };

  const loadClarity = () => {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "q0lnksplxh");
  };

  const loadScripts = () => {
    loadCustomScripts();
    loadClarity();
    loadAccesibie();
  };

  document.addEventListener("UserInteracted", loadScripts, false);
})();
